<template lang="html">
  <div class="fileFor">
    <div class="fileForContent">

      <!-- 表单 -->
      <div class="fileForForm">
        <!-- 公司名称 -->
        <div class="nameModel">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>公司：</p>
          </div>
          <input class="usercompanyName" placeholder="请输入公司名称" name="usercompanyName" maxlength="16" type="text" v-model="userCompanyName">
        </div>

        <!-- 职位 -->
        <div class="nameModel">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>职位：</p>
          </div>
          <input class="userPosition" placeholder="请输入职位" name="userPosition" maxlength="16" type="text" v-model="userPosition">
        </div>

        <!-- 姓名 -->
        <div class="nameModel">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>姓名：</p>
          </div>
          <input class="userName" placeholder="请输入姓名" name="userName" maxlength="16" type="text" v-model="userName">
        </div>

        <!-- 手机号 -->
        <div class="cellPhoneNumberModel">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>手机：</p>
          </div>
          <input class="userPhone" placeholder="请输入手机号码" name="userPhone" maxlength="16" type="text" v-model="userPhone">
        </div>

        <!-- 验证码 -->
        <div class="verificationCodeModel">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>验证码：</p>
          </div>
          <div class="verificationCodeCon">
            <input class="verificationCode" placeholder="请输入验证码" name="verificationCode" maxlength="6" type="text" v-model="code">
            <div class="codeNum" :class="{ checkValid: codeEnabled }" @click="getSmsCode">{{ buttonMsg }}</div>
          </div>
        </div>

        <!-- 邮箱 -->
        <div class="cellPhoneNumberModel">
          <div class="label">
            <p class="email"><span></span>邮箱：</p>
          </div>
          <input class="userEmail" placeholder="请输入邮箱地址" name="userEmail" maxlength="50" type="text" v-model="userEmail">
        </div>

        <!-- 参会时间和方式 -->
        <div class="paymentModel">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>参会时间和方式：</p>
          </div>

          <div class="">
            <div class="postDirectionOption postDirectionOptionWay" @click="getPackage('1')">
              <img class="checkIcon" v-if="setMealType == '1'" src="@/assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <p>4月10日 (含午餐及门票)</p>
            </div>

            <div class="postDirectionOption postDirectionOptionWay" @click="getPackage('2')">
              <img class="checkIcon" v-if="setMealType == '2'" src="@/assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <p>4月11日 (含午餐及门票)</p>
            </div>

            <div class="postDirectionOption postDirectionOptionWay"  @click="getPackage('3')">
              <img class="checkIcon" v-if="setMealType == '3'" src="@/assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <p>4月10日-4月11日 (含2天午餐及门票)</p>
            </div>

            <div class="postDirectionOption postDirectionOptionWay"  @click="getPackage('0')">
              <img class="checkIcon" v-if="setMealType == '0'" src="@/assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <div class="invitationCode">
                <div class="label">
                  <p>邀请码：</p>
                </div>
                <input class="userInvitationCode" placeholder="填写邀请码可免费参会" name="userInvitationCode" maxlength="16" type="text" v-model="userInvitationCode">
              </div>
            </div>
          </div>
        </div>

        <!-- 支付方式 -->
        <div class="paymentModel" v-show="setMealType != '0'">
          <div class="label">
            <img src="@/assets/image/postCertificate/icon6.png" alt="">
            <p>支付方式：</p>
          </div>

          <div class="paymentWay">
            <div class="postDirectionOption postDirectionOptionWay" @click="getPayTypeItemClick('wechat')">
              <img class="checkIcon" v-if="thirdPartPayType == 'wechat'" src="@/assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <img class="paymentImg" src="@/assets/image/payment/wechat_pay.png" alt="">
              <p>微信支付</p>
            </div>

            <div class="postDirectionOption postDirectionOptionWay" v-if="!isInWx" @click="getPayTypeItemClick('alipay')">
              <img class="checkIcon" v-if="thirdPartPayType == 'alipay'" src="@/assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <img class="paymentImg" src="@/assets/image/payment/alipay.png" alt="">
              <p>支付宝支付</p>
            </div>
          </div>
        </div>

        <!-- 合计 -->
        <div class="totalMoneyModel" v-show="setMealType != '0'">
          <div>合计：</div>
          <p>￥{{ finalAmount }}</p>
        </div>

        <div class="submitModel" @click="getSubmit">
          {{ submitButtonMsg }}
        </div>
      </div>
    </div>

    <div v-show="hintShow" class="hintMod">
      <p>{{ hintCon }}</p>
    </div>
    <div id="qrcodeBox" @click="hideQRCodeBox" :style="`display:${showQRCodeBox ? 'block' : 'none'}`">
			<div ref="qrcode" class="qrcode-wrapper"></div>
		</div>
  </div>
</template>

<script>
import utils from '@/utils/utils'
import {pagebase} from '@/utils/http.js';
import WxPay from '@/utils/wxpay'
import QRCode from '@/utils/qrcode.js'

var word = /^([\u4E00-\u9FA5]+|[a-zA-Z]+)+$/;

export default {
  data() {
    return {
      pagebase: pagebase,
      activity: {},
      aid: this.$route.query.activity_id || '',
      userCompanyName: '',
      userPosition: '',
      userName: '',
      userPhone: '',
      code: '',
      userEmail: '',
      limitTime: 60,
      buttonMsg: '获取验证码',
      codeEnabled: false,
      hintShow: false,
      hintTime: 1,
      hintCon: '',
      setMealType: '1',  /* 1: 4月10日, 2: 4月11日, 3: 4月10日-4月11日 */
      userInvitationCode: '',
      thirdPartPayType: 'wechat',  /* wechat, alipay*/
      finalAmount: '0',
      succeedUrl: decodeURIComponent(this.$route.query.succeed_url) || '',
      order: localStorage.getItem('tradeSn') || '',
      openid: this.$route.query.openid || '',
      isInWx: utils.browserChecker.isWx(),
      isInPc: !(utils.browserChecker.isIOS() || utils.browserChecker.isAndroid()),
      channel: this.$route.query.channel || '',
      submitButtonMsg: '提交并支付',
      showQRCodeBox: false,
    }
  },

  created() {
    this.getOrderInfo();
    this.wx = new WxPay();

    /*如果当前页面存在订单，则先查询订单状态*/
    this.order && this.polling();
  },

  mounted() {
    // 组件挂载后自动生成二维码
    this.generateQRCode()
  },

  destroyed() {
    this.intervalPolling && clearInterval(this.intervalPolling)
  },

  methods: {
    // 活动详情
    getOrderInfo() {
      this.$http('activity/Info', {
        params: {
          activity_id: this.aid
        }
      }).then(res => {
        if (res.code >= 0) {
          this.activity = res.data;
          this.finalAmount = this.activity.custom_1;
          document.title = '信息填写';
        } else {
          this.setHintCon(res.msg)
        }
      })
    },

    // 获取验证码
    getSmsCode() {
      if (this.codeEnabled) {
        return;
      }
      if (!this.userPhone) {
        this.setHintCon('请输入手机号');
        return;
      }
      if (!utils.checkPhone(this.userPhone)) {
        this.setHintCon('请输入正确的手机号');
        return;
      }

      this.$http.get('/Registered/getPhoneSmsCode', {
        params: utils.cso({
          phone: this.userPhone,
          phone_head: 86,
          type: 10,
          client: 'H5'
        })
      }).then((res) => {
        if (res.code >= 0) {
          this.codeEnabled = true;
          this.buttonMsg = this.limitTime + 's'
          this.timer = window.setInterval(() => {
            this.limitTime--
            this.buttonMsg = this.limitTime + 's'
            if (this.limitTime < 0) {
              window.clearInterval(this.timer)
              this.codeEnabled = false;
              this.buttonMsg = '获取验证码'
              this.limitTime = 60
            }
          }, 1000)
        } else {
          this.setHintCon(res.msg);
        }
      })
    },

    getPackage(e) {
      this.setMealType = e;
      this.submitButtonMsg = '提交并支付';
      if (e == '1') {
        this.finalAmount = this.activity.custom_1;
        this.userInvitationCode = ''
      } else if (e == '2') {
        this.finalAmount = this.activity.custom_2;
        this.userInvitationCode = ''
      } else if (e == '3') {
        this.finalAmount = this.activity.custom_3;
        this.userInvitationCode = ''
      } else if (e == '0') {
        this.finalAmount = '0';
        this.submitButtonMsg = '提交';
      }
    },

    // 支付方式选择
    getPayTypeItemClick(type) {
      this.thirdPartPayType = type;
    },

    // 提交验证
    getSubmit() {
      if (this.userCompanyName != '') {
        if (this.userPosition != '') {
          if (word.test(this.userName) && this.userName) {
            if (utils.checkPhone(this.userPhone) && this.userPhone) {
              if (this.code != '') {
                if (this.setMealType == '0' && this.userInvitationCode == '') {
                  this.setHintCon('请输入邀请码');
                  return;
                }

                this.$http({
                    url: '/activity/activityRegister',
                    method: 'post',
                    params: {
                      activity_id: this.aid,
                      company: this.userCompanyName,
                      position: this.userPosition,
                      name: this.userName,
                      phone: this.userPhone,
                      sms_code: this.code,
                      email: this.userEmail,
                      accommodation_id: this.setMealType,
                      invitation_code: this.userInvitationCode,
                      channel: this.channel,
                    }
                  }).then(res => {
                    if (res.code >= 0) {
                      if (!res.data.need_pay) {
                        window.location.replace(this.succeedUrl)
                      } else {
                        this.payOrder(res.data)
                      }
                    } else {
                      this.setHintCon(res.msg)
                      if (res.code == -21) {
                        setTimeout(() => {
                          window.location.replace(this.succeedUrl)
                        }, 2000)
                      }
                    }
                  })
              } else {
                this.setHintCon('请输入验证码');
                return;
              }
            } else {
              this.setHintCon('请输入正确的手机号');
              return;
            }
          } else {
            this.setHintCon('请输入姓名');
            return;
          }
        } else {
          this.setHintCon('请输入职位');
          return;
        }
      } else {
        this.setHintCon('请输入公司名称');
        return;
      }
    },

    payOrder(snData) {
      this.order = snData.order_sn;
      let payTypeMap = {
        wechat: 'WechatPay_MWeb',
        alipay: 'Alipay_LegacyWap',
        elecnest: 'Coin'
      }
      if (this.isInPc) {
        /*如果不是在ios或android内，则默认是pc内打开*/
        payTypeMap.wechat = 'WechatPay_Native'
        payTypeMap.alipay = 'Alipay_LegacyExpress'
      } else if (this.isInWx) {
        /*若是手机微信内打开，则微信支付时转用jsApi支付*/
        payTypeMap.wechat = 'WechatPay_Js'
      }
      if (this.thirdPartPayType == 'alipay') {
        /*如果是支付宝支付，那么只能在当前上报数据给b站，之后跟踪不到*/
        window.bilicm.mbase.report_data()
      }

      this.$http('activity/dopay', {
        params: {
          gateway: payTypeMap[this.thirdPartPayType],
          type: 'purchase',
          order_sn: this.order,
          amount: this.finalAmount,
          openid: this.openid,
          succeed_url: this.succeedUrl || '',
        }
      }).then(res => {
        if(res.code >= 0){
					let data = res.data
					if(data.status == 'paid'){
						localStorage.removeItem('tradeSn')
						clearInterval(this.intervalPolling)
						this.setHintCon('支付成功')
						window.location.replace(this.succeedUrl)
					}else{
						data.tradeSn && localStorage.setItem('tradeSn', data.tradeSn)
						switch(this.thirdPartPayType){
							case 'wechat': {
								if(this.isInPc){
									/*如果是网页用微信支付，则弹起支付二维码*/
									this.QRCodeUrl = data.qrcodeUrl
									this.showQRCodeBox = true
                  this.generateQRCode()
									this.polling()
									return;
								}else if(this.isInWx){
									/*如果是微信内支付，则调用jsapi唤起微信支付*/
									this.wx.pay(data)
									this.polling()
								}else{
									this.polling()
									location.href = data.mwebUrl
								}
								break
							}
							case 'alipay': {
								if(this.isInPc){
									/*如果是网页用支付宝支付，则跳转支付二维码*/
									location.href = data.qrcodeUrl
								}else{
									setTimeout(() => {
										document.write(data.paymentHtml)
									}, 500)
								}
								break
							}
						}
					}
				} else {
          this.setHintCon(res.msg)
        }
      })
    },

    polling(){
			let tradeSn = localStorage.getItem('tradeSn')
			this.intervalPolling && clearInterval(this.intervalPolling)
			this.intervalPolling = setInterval(() => {
				if(tradeSn){
					this.$http('activity/getTradeStatus', {
						params: {trade_sn: tradeSn}
					}).then(res => {
						if(res.code >= 0 && res.data.status == 'paid'){
							localStorage.removeItem('tradeSn')
							clearInterval(this.intervalPolling)
							this.setHintCon('支付成功')
							setTimeout(() => {
								window.location.replace(this.succeedUrl)
							}, 1000)
						}
					})
				}else{
					clearInterval(this.intervalPolling)
				}
			}, 1500)
		},

    hideQRCodeBox(){
			this.showQRCodeBox = false
		},
    generateQRCode() {
      // 确保DOM已经更新
      this.$nextTick(() => {
        // 清空容器，避免重复生成
        this.$refs.qrcode.innerHTML = ''
        
        // 创建二维码实例
        this.qrCode = new QRCode(this.$refs.qrcode, {
          text: this.QRCodeUrl,        // 要转换的字符串
          width: 200,               // 二维码宽度
          height: 200,              // 二维码高度
          colorDark: '#000000',     // 二维码颜色
          colorLight: '#ffffff',    // 背景颜色
          correctLevel: QRCode.CorrectLevel.H // 容错级别
        })
      })
    },

    // 提示信息
    setHintCon(e) {
      window.clearInterval(this.timers)
      this.hintCon = e;
      this.hintShow = true;
      this.timers = window.setInterval(() => {
        this.hintTime--
        if (this.hintTime < 0) {
          window.clearInterval(this.timers)
          this.hintShow = false
          this.hintTime = 1
        }
      }, 1000)
    },
  },

  watch: {
    // 监听qrText变化，自动重新生成二维码
    QRCodeUrl(newVal) {
      if (newVal) {
        this.generateQRCode()
      }
    }
  },
}
</script>

<style lang="css" scoped>
.fileForContent {
  box-sizing: border-box;
}

.heading--second {
  font-size: 2rem;
  color: rgb(249, 96, 46);
  margin-top: 2rem;
}

/* 表单样式 */
.fileForForm {
  box-sizing: border-box;
  padding: 2rem 1.5rem;
}

.methodModel {
  box-sizing: border-box;
}

.label {
  box-sizing: border-box;
  display: flex;
  font-size: 1.6rem;
  font-weight: 600;
  color: #333333;
}

.certificateName {
  align-items: center;
}

.certificateName .label+.value {
  font-size: 1.4rem;
  color: #333333;
}

.label img {
  width: auto;
  height: .7rem;
  margin-top: .4rem;
  margin-right: .2rem;
}

.companyName {
  width: 11rem;
}

/* 方向 */
.postDirection {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.postDirectionOption {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: .9rem;
  margin-bottom: 1rem;
}

.postDirectionOption p {
  font-size: 1.6rem;
  color: #333333;
}

.checkIcon {
  width: 2rem;
  height: 2rem;
  margin-right: .65rem;
}

.checkInactive {
  width: 2rem;
  height: 2rem;
  background-image: url('~@/assets/image/postCertificate/icon4.png');
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: .65rem;
}

.invitationCode {
  display: flex;
  align-items: center;
}

.invitationCode .label {
  width: 7rem;
}

/* 姓名 */
.nameModel {
  box-sizing: border-box;
  display: flex;
  padding: 1.5rem 0;
  margin-bottom: 1rem;
  border-bottom: .05rem solid #EEEEEE;
}

.userName,
.usercompanyName,
.userPosition,
.userEmail {
  box-sizing: border-box;
  width: 27.8rem;
  font-size: 1.6rem;
  color: #333333;
  border: none;
  outline: none;
}

.userInvitationCode {
  box-sizing: border-box;
  font-size: 1.6rem;
  color: #333333;
  border: none;
  outline: none;
}

.userName[name="userName"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

.usercompanyName[name="usercompanyName"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

.userPosition[name="userPosition"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

.userEmail[name="userEmail"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

.userInvitationCode[name="userInvitationCode"]::-webkit-input-placeholde {
  color: #C0C4CC;
}

/* 身份证号 */
.identityCardModel {
  box-sizing: border-box;
  display: flex;
  padding: 1.5rem 0;
  border-bottom: .05rem solid #EEEEEE;
}

.identityCard {
  box-sizing: border-box;
  width: 24.6rem;
  font-size: 1.6rem;
  color: #333333;
  border: none;
  outline: none;
}

.identityCard[name="identityCard"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

/* 地址 */
.siteModel {
  box-sizing: border-box;
  margin-top: 1.35rem;
}

.mailLocation {
  box-sizing: border-box;
  width: 33.85rem;
  height: 10.3rem;
  margin-left: 1rem;
  margin-top: .45rem;
  padding: .95rem 1.6rem;
  font-size: 1.6rem;
  color: #333333;
  font-family: -webkit-body;
  resize: none;
  outline: none;
  border: none;
  border-radius: .4rem;
  background-color: #F6F6F6;
}

.mailLocation[name="mailLocation"]::-webkit-input-placeholder {
  color: #B0B0B0;
}

.siteAnnotation {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333333;
  margin-top: .3rem;
  margin-left: 1rem;
}

/* 备注 */
.remarkModel {
  box-sizing: border-box;
  display: flex;
  padding: 1.5rem 0;
  margin-top: 1rem;
  border-bottom: .05rem solid #EEEEEE;
}

.remarkModel .label img {
  opacity: 0;
}

.remark {
  box-sizing: border-box;
  width: 27.8rem;
  font-size: 1.6rem;
  color: #333333;
  border: none;
  outline: none;
}

.remark[name="remark"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

/* 手机号 */
.cellPhoneNumberModel {
  box-sizing: border-box;
  display: flex;
  padding: 1.5rem 0;
  border-bottom: .05rem solid #EEEEEE;
}

.userPhone {
  box-sizing: border-box;
  width: 26.2rem;
  font-size: 1.6rem;
  color: #333333;
  border: none;
  outline: none;
}

.userPhone[name="userPhone"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

.email span {
  color: #FFFFFF;
  margin-right: 1.1rem;
}

/* 验证码 */
.verificationCodeModel {
  box-sizing: border-box;
  display: flex;
  padding: 1.5rem 0;
  border-bottom: .05rem solid #EEEEEE;
}

.verificationCodeCon {
  box-sizing: border-box;
  width: 26.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.verificationCode {
  box-sizing: border-box;
  width: 9.6rem;
  font-size: 1.6rem;
  color: #333333;
  border: none;
  outline: none;
}

.verificationCode[name="verificationCode"]::-webkit-input-placeholder {
  color: #C0C4CC;
}

.codeNum {
  box-sizing: border-box;
  width: 8.1rem;
  font-size: 1.6rem;
  color: #1383FC;
  margin-right: .6rem;
  text-align: center;
}

.checkValid {
  color: #F7443F;
}

/* 支付方式 */
.paymentModel {
  box-sizing: border-box;
  margin-top: 3rem;
}

.paymentWay {
  display: flex;
}

.postDirectionOptionWay {
  margin-right: 2rem;
}

.paymentImg {
  width: 2rem;
  height: 2rem;
  margin-right: .55rem;
}

/* 合计 */
.totalMoneyModel {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3.15rem;
}

.totalMoneyModel div {
  font-size: 1.4rem;
  color: #3F454B;
}

.totalMoneyModel p {
  font-size: 2.4rem;
  font-weight: 600;
  color: #E50120;
}

/* 提交 */
.submitModel {
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F7443F;
  color: #FCFCFC;
  font-size: 1.7rem;
  border-radius: .4rem;
  margin-top: 3rem;
}

/* 提示 */
.hintMod {
  box-sizing: border-box;
  position: fixed;
  bottom: 45%;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
}

.hintMod p {
  box-sizing: border-box;
  padding: 0 1.5rem;
  background-color: rgba(29, 32, 35, 0.5);
  font-size: 1.3rem;
  color: #FFFFFF;
  max-width: 65%;
  height: 4rem;
  border-radius: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

#qrcodeBox{
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	text-align: center;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 10;
}
#qrcodeBox img{
	width: 50%;
	height: 50%;
	margin-top: 20%;
}
.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.qrcode-wrapper {
  margin: 200px 0;
	display: inline-block;
	border: 8px solid #FFF;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.qrcode-content {
  margin-top: 15px;
  font-size: 14px;
  color: #666;
}
</style>